var React = require('react');

function IconGrid (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2,13.499h4V10.5H2V13.499z M18,13.499h4V10.5h-4V13.499z M10,13.499h4V10.5h-4\r\n\t\t\tV13.499z M2,6.5h4v-3H2V6.5z M18,3.5v3h4v-3H18z M10,6.5h4v-3h-4V6.5z M2,20.5h4v-3H2V20.5z M18,20.5h4v-3h-4V20.5z M10,20.5h4v-3\r\n\t\t\th-4V20.5z"}))));
}

IconGrid.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","xmlSpace":"preserve"};

module.exports = IconGrid;

IconGrid.default = IconGrid;
